import { classNames } from '@commenda/utils';
import { StepperItemIcon } from './StepperItemIcon';

export const StepperItem = ({
  label,
  isActive,
  isCompleted,
  onClick,
  disabled,
  description,
}: {
  label: string;
  isActive: boolean;
  isCompleted: boolean;
  onClick: () => void;
  disabled?: boolean;
  description?: string;
}) => {
  return (
    <div
      className={classNames(
        'p-lg rounded-md flex gap-lg group',
        isActive && !disabled ? 'bg-bg-active-dark' : 'bg-transparent',
        disabled ? 'cursor-not-allowed pointer-events-none' : 'cursor-pointer'
      )}
      onClick={onClick}
    >
      <StepperItemIcon
        isCompleted={isCompleted}
        disabled={!!disabled}
        isActive={isActive}
      />
      <div className="flex flex-col">
        <div
          className={classNames(
            'txt-small-medium',
            disabled ? 'text-text-disabled' : 'text-text-secondary'
          )}
        >
          {label}
        </div>
        {description ? (
          <p
            className={classNames(
              'txt-small-regular',
              disabled ? 'text-text-disabled' : 'text-text-tertiary'
            )}
          >
            {description}
          </p>
        ) : null}
      </div>
    </div>
  );
};
